import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { VideoPlayer } from "@/components/MediaSlot";
import { useLang } from "@/i18n";
import { track } from "@/lib/api";
import { useSettings } from "@/lib/settings";
import { IconTile } from "@/components/IconArt";

const CLIPS = [
  ["customer_personal_video", "personal"],
  ["customer_parents_video", "family"],
  ["customer_errand_video", "errands"],
  ["customer_homehelp_video", "homehelp"],
  ["customer_events_video", "events"],
  ["customer_shopping_video", "shopping"],
];

export default function SeeHow() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const media = useSettings().media || {};
  return (
    <section id="see-how" className="chela-section">
      <div className="chela-container">
        <h2 className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-[#121316]">{t("seehow_h2")}</h2>
        <div className="mt-8 grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {CLIPS.map(([key, img]) => {
            const slot = media[key] || {};
            const poster = slot.poster;
            return (
              <div key={key} data-testid={`seehow-${key}`} className="chela-card rounded-3xl overflow-hidden flex flex-col" style={{ transform: "none" }}>
                <div className="aspect-[4/3] bg-[#121316]">
                  {(slot.url || "").trim()
                    ? <VideoPlayer slot={slot} poster={poster} testid={`video-${key}`} alt={slot.caption_en || ""} />
                    : <IconTile kind={img} lang={lang} className="w-full h-full" />}
                </div>
                <div className="p-5 flex flex-col gap-3 flex-1">
                  <p className="font-display font-bold text-lg text-[#121316]">{slot.caption_hi}</p>
                  <p className="text-sm text-[#5A5D65] flex-1">{slot.caption_en}</p>
                  <button data-testid={`seehow-book-${key}`} onClick={() => { track("book_click", { source: `seehow_${key}` }); navigate("/book"); }} className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full btn-saffron font-bold">
                    {t("book")} <ArrowRight size={18} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
